import { render, staticRenderFns } from "./PhoneAuth.vue?vue&type=template&id=685d231e&scoped=true&"
import script from "./PhoneAuth.vue?vue&type=script&lang=js&"
export * from "./PhoneAuth.vue?vue&type=script&lang=js&"
import style0 from "./PhoneAuth.vue?vue&type=style&index=0&id=685d231e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "685d231e",
  null
  
)

export default component.exports